import { graphql } from '../../gql'

export const EMPLOYMENT_DETAIL_FRAGMENT = graphql(`
  fragment CustomerEmploymentDetail on Employment {
    id
    createdAt
    updatedAt
    company {
      id
      name
    }
    role
    state
    nextStates
  }
`)

export const getEmploymentList = graphql(`
  query getCustomerEmploymentList($options: EmploymentListOptions) {
    employments(options: $options) {
      totalItems
      items {
        ...CustomerEmploymentDetail
      }
    }
  }
`)
